import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import CircularProgress from '@material-ui/core/CircularProgress';
import { SelectValidator } from 'react-material-ui-form-validator';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface ITitleDropDownProps {
    setTitle?: (event) => void;
    title: string | undefined;
    disabled: boolean;
    childMode: boolean;
    required: boolean;
    name: string;
}

interface ITitleDropDownState {
    model: string[];
    loaded: boolean;
}

class TitleDropDown extends Component<ITitleDropDownProps & WithStyles<typeof styles>, ITitleDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        if (this.props.childMode === false) {
            fetch('api/DropDown/getTitles?sex=B')
                .then(response => response.json()).then((data) => {
                    this.setState({
                        model: data,
                        loaded: true,
                    });
                });
        } else {
            fetch('api/DropDown/getTitles?sex=B&childMode=true')
                .then(response => response.json()).then((data) => {
                    this.setState({
                        model: data,
                        loaded: true,
                    });
                });
        }
    }

    componentDidUpdate(prevProps) {

    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items = this.state.model.map(item =>
                <MenuItem key={item} value={item}>{item}</MenuItem>
            );

            if (this.props.required === false) {
                items.push(<MenuItem key="defaultTitleVal" value=''>Not Set</MenuItem>);
            }
        }

        return (
            <SelectValidator
                label={this.props.childMode ? "Your Child's Title *" : this.props.required ? "Title *" : "Title"}
                name={this.props.name}
                title={this.props.childMode ? "Your Child's Title *" : this.props.required ? "Title *" : "Title"}
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.title}
                onChange={this.props.disabled ? undefined : this.props.setTitle}
                disabled={this.props.disabled}
                validators={this.props.required ? ['required'] : undefined}
                errorMessages={this.props.required ? ['This field is required'] : undefined}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }

}

export default withStyles(styles)(TitleDropDown);